import React from 'react';
import CardWithBackgroundImage from 'components/CardWithBackgroundImage';
import Subheading, { SubheadingColourScheme } from 'components/Subheading';
import { ASSET_PREFIX } from 'utils/constants';
import { EntryMethod } from 'components/enter/EntryMethod';
import { extendClassName } from 'utils/common';

const WhenYouWinChooseFrom = ({ entryMethod, additionalClassName = '' }) => {
  const IMAGE_DIR = '/enter/when-you-win-choose-from';
  const images = [
    {
      renderItem: (key) => (
        <CardWithBackgroundImage
          key={key}
          imageDirectory={IMAGE_DIR}
          imageFname="trips-and-stays"
          imageOpacity={0.9}
        >
          <Subheading
            colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
          >
            Trips & Stays
          </Subheading>
        </CardWithBackgroundImage>
      ),
    },
    {
      renderItem: (key) => (
        <CardWithBackgroundImage
          key={key}
          imageDirectory={IMAGE_DIR}
          imageFname="tech-prizes"
          imageOpacity={0.9}
        >
          <Subheading
            colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
          >
            Tech Prizes
          </Subheading>
        </CardWithBackgroundImage>
      ),
    },
    {
      renderItem: (key) => (
        <CardWithBackgroundImage
          key={key}
          imageDirectory={IMAGE_DIR}
          imageFname="lifestyle-prizes"
          imageOpacity={0.9}
        >
          <Subheading
            colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
          >
            Lifestyle Prizes
          </Subheading>
        </CardWithBackgroundImage>
      ),
    },
    {
      renderItem: (key) => (
        <CardWithBackgroundImage
          key={key}
          imageDirectory={IMAGE_DIR}
          imageFname="experiences"
          imageOpacity={0.9}
        >
          <Subheading
            colourScheme={SubheadingColourScheme.WHITE_TEXT_BLACK_SHADOW}
          >
            Experiences
          </Subheading>
        </CardWithBackgroundImage>
      ),
    },
  ];

  return (
    <div
      className={extendClassName(
        'whenYouWinChooseFrom fullWidth flexCentered',
        additionalClassName,
      )}
    >
      <div className="whenYouWinTextAndArrow">
        <p className="xlarge font-extrabold">
          Pick numbers, match to win & choose from
        </p>
        <img
          src={`${ASSET_PREFIX}/images/enter/when-you-win-choose-from/${
            entryMethod === EntryMethod.FreeSubscription
              ? 'arrow-pink.png'
              : 'arrow-green.svg'
          }`}
        />
      </div>

      <div className="prizeCategories mobile fullWidth flexCentered">
        {images.map((x, i) => x.renderItem(i))}
        {/* <ImageGallery
          items={images}
          showThumbnails={false}
          showFullscreenButton={false}
          useBrowserFullscreen={false}
          showBullets
          autoPlay
          disableKeyDown={true}
          slideInterval={5000}
          showPlayButton={false}
          additionalClass="gallery"
          showNav={false}
        /> */}
      </div>

      <div className="prizeCategories desktop flexCentered space-y-4">
        {images.map((img, idx) => img.renderItem(idx))}
      </div>

      <style jsx>
        {`
          .whenYouWinChooseFrom {
            padding: 3.5em 0;
          }

          .whenYouWinTextAndArrow {
            position: relative;
          }

          .whenYouWinTextAndArrow img {
            width: 30px;
            position: absolute;
            bottom: 0;
            right: -8px;
          }

          .prizeCategories {
            margin-top: 1em;
          }

          .prizeCategories.mobile {
            display: flex;
          }

          .prizeCategories.desktop {
            display: none;
          }

          h4 {
            letter-spacing: 0;
            text-transform: none;
            font-weight: 800;
            font-size: 1.8em;
            line-height: 1.1;
          }

          :global(.whenYouWinChooseFrom .gallery) {
            width: 100%;
            border-radius: 10px;
            overflow: hidden;
          }

          :global(.whenYouWinChooseFrom .gallery .cardWithBackgroundImage) {
            padding: 5em 0;
            background: black;
          }

          @media (min-width: 1000px) {
            .prizeCategories.mobile {
              display: none;
            }

            .prizeCategories.desktop {
              display: flex;
            }

            :global(.prizeCategories.desktop .cardWithBackgroundImage) {
              width: 350px;
              height: 150px;
              border-radius: 10px;
              background: black;
            }

            :global(.prizeCategories.desktop a) {
              margin-bottom: 1em;
            }

            :global(.prizeCategories.desktop a:last-child) {
              margin-bottom: 0;
            }
          }
        `}
      </style>
    </div>
  );
};
export default WhenYouWinChooseFrom;
